(function () {
  'use strict';
  var loaded = false;
  var resetting = false;
  var privacyRequested = false;
  function ensurePrivacyReady() {
    var shopify = window.Shopify;
    if (privacyRequested || !shopify || shopify.customerPrivacy || typeof shopify.loadFeatures !== 'function') return;
    privacyRequested = true;
    shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) update();
    });
  }
  function allowed() {
    var cmp = window.Consentmo;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!(cmp && typeof cmp.marketingAllowed === 'function' && cmp.marketingAllowed() === true
      && privacy && typeof privacy.saleOfDataAllowed === 'function' && privacy.saleOfDataAllowed() === true);
  }
  // Outside the consent regions Consentmo fires consentmoSignal_onLoad before window.Consentmo exists and
  // sends no later signal, so re-check once the API appears (bounded: 240 x 250 ms).
  var waiting = false;
  function waitForConsentmo() {
    if (waiting || window.Consentmo || typeof window.setInterval !== 'function') return;
    waiting = true;
    var tries = 0;
    var id = window.setInterval(function () {
      tries += 1;
      if (!window.Consentmo && tries < 240) return;
      window.clearInterval(id);
      waiting = false;
      if (window.Consentmo) update();
    }, 250);
  }
  function update() {
    ensurePrivacyReady();
    if (!window.Consentmo) {
      waitForConsentmo();
      return;
    }
    if (!allowed()) {
      if (loaded && !resetting) {
        resetting = true;
        window.location.reload();
      }
      return;
    }
    if (loaded || resetting) return;
    loaded = true;
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://shopify-init.blackcrow.ai/js/core/renuebyscience-us.js?shop=renuebyscience-us.myshopify.com&tagSrc=ShopifyThemeAppExtension';
    document.head.appendChild(script);
  }
  document.addEventListener('consentmoSignal_onLoad', update);
  document.addEventListener('consentmoSignal', update);
  document.addEventListener('visitorConsentCollected', update);
  update();
})();
